// extracted by mini-css-extract-plugin
export default {"spinner__con":"styles_spinner__con__AKmcb","spinner":"styles_spinner__Wyr9B"};